import {mainSplitApi} from "../../../api"
import urls from "../../../constants/urls"

type metaType = {
    status_code: number
    success: boolean
    message: string
}

type responseType = {
    access_token?: string
}

type LoginResponse = {
    meta: metaType
    data: responseType
}

type LoginRequest = {
    phone: string | null
    name: string | null
    latitude: string | null
    longitude: string | null
    vendor_code: string | null
}

const login = mainSplitApi.injectEndpoints({
    endpoints: build => ({
        loginApi: build.mutation<LoginResponse, LoginRequest>({
            query: body => {
                return({
                url: `/digitized_reports/${urls.AUTH_URL}`,
                method: "POST",
                body,
            })},
        }),
        logoutApi: build.mutation({
            query: body => {
                return({
                url: `/digitized_reports/logout`,
                method: "POST",
            })},
        }),
    }),
})

export const {useLoginApiMutation, useLogoutApiMutation} = login
